// extracted by mini-css-extract-plugin
export default {"custom_tweet":"styles-module__custom_tweet___LCGhS","custom_tweet_icon":"styles-module__custom_tweet_icon___RGUpM"};